module.exports = __webpack_public_path__ + "static/img/8bg_3.096baed.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/8bg_3.png
// module id = 754
// module chunks = 1